/* eslint-disable react/prop-types */

import type { AppContextValue } from 'src/components/app-context';
import { AppContext } from 'src/components/app-context';
import React from 'react';
import { connect } from 'react-redux';
import { Video, VideoThumbnail } from 'src/components/carousel';
import { MediumCardHorizontalScroll } from 'src/components/horizontal-scroll/variants/medium-card-horizontal-scroll';
import type { VideoListingFragment } from 'src/types';
import Lightbox from '../../../../components/lightbox';

import brandMediaActions from '../../actions';

import * as S from './styles';

type VideoListingProps = Pick<VideoListingFragment['media'], 'videos'> &
  typeof brandMediaActions;

class VideoListing extends React.PureComponent<
  VideoListingProps,
  {
    open: boolean;
    position: number;
  }
> {
  declare context: AppContextValue;

  constructor(props: VideoListingProps) {
    super(props);

    this.state = {
      open: false,
      position: 0,
    };

    this.close = this.close.bind(this);
  }

  open(atIndex: number) {
    this.props.brandMediaToggle(true);
    this.setState({
      open: true,
      position: atIndex,
    });
  }

  close = () => {
    this.props.brandMediaToggle(false);
    this.setState({
      open: false,
    });
  };

  render() {
    const { videos } = this.props;
    const { t } = this.context;

    if (!videos) {
      return null;
    }

    const thumbnails = videos.map(video => (
      <VideoThumbnail key={video!.source_id!} src={video!.thumbnail!} />
    ));
    const items = videos.map(video => (
      <Video src={video!.embed_url!} key={video!.source_id}>
        <p>{t('product', 'video.brand-disclaimer')}</p>
      </Video>
    ));

    return (
      <>
        {this.state.open && (
          <Lightbox
            items={items}
            thumbnails={thumbnails}
            position={this.state.position}
            close={this.close}
            isOpen={this.state.open}
          />
        )}
        <S.StyledPanel>
          <MediumCardHorizontalScroll>
            {videos.map((video, index) => (
              <S.Button
                className="brand-page-video"
                type="button"
                key={video!.source_id!}
                tabIndex={0}
                onClick={() => {
                  this.open(index);
                }}
              >
                {thumbnails[index]}
              </S.Button>
            ))}
          </MediumCardHorizontalScroll>
        </S.StyledPanel>
      </>
    );
  }
}

VideoListing.contextType = AppContext;

export const VideoListingTest = VideoListing;

export default connect(null, brandMediaActions)(VideoListing);
